import React, { useEffect } from 'react';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer/Footer';
import ComingSoon from '../components/Pages/ComingSoon/ComingSoon';
import { useScrollState } from '../stores/scrollStore';

const ComingSoonPage: React.FC = () => {
  const { isScrolled, scrollProgress, throttledUpdateScrollState } = useScrollState();
  useEffect(() => {
    // Use throttled scroll handler instead of polling
    const handleScroll = () => {
      throttledUpdateScrollState(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [throttledUpdateScrollState]);

  return (
    <>
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      <div>
        <ComingSoon />
        <Footer />
      </div>
    </>
  );
};

export default ComingSoonPage;
